<div class="approval-policies-container">
  <!-- Header -->
  <div class="policies-header">
    <h2 class="policies-title">
      <i class="fas fa-cog"></i>
      Políticas de Aprobación
    </h2>
    <p class="policies-subtitle">
      Configura los parámetros de aprobación automática de créditos
    </p>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner">
      <i class="fas fa-spinner fa-spin"></i>
      <span>Cargando políticas...</span>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-container">
    <div class="error-message">
      <i class="fas fa-exclamation-triangle"></i>
      <span>{{ error }}</span>
      <button class="btn btn-primary" (click)="loadApprovalPolicies()">
        <i class="fas fa-sync-alt"></i>
        Reintentar
      </button>
    </div>
  </div>

  <!-- Main Content -->
  <div *ngIf="!loading && !error && hasData()" class="policies-content">

    <!-- Tab Navigation Fase 2 unificada: 4 top-level tabs -->
    <ul class="nav nav-tabs policies-tabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          [class.active]="activeTab === 'motor-decision'"
          (click)="setActiveTab('motor-decision')"
          type="button">
          <i class="fas fa-bullseye"></i>
          Motor de Decisión
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          [class.active]="activeTab === 'mt-scoring'"
          (click)="setActiveTab('mt-scoring')"
          type="button">
          <i class="fas fa-layer-group"></i>
          MT Scoring
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          [class.active]="activeTab === 'credolab'"
          (click)="setActiveTab('credolab')"
          type="button">
          <i class="fas fa-shield-alt"></i>
          Credolab
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          [class.active]="activeTab === 'history'"
          (click)="setActiveTab('history')"
          type="button">
          <i class="fas fa-history"></i>
          Historial
        </button>
      </li>
    </ul>

    <!-- Tab Content -->
    <div class="tab-content-wrapper">

      <!-- Tab 1: Motor de Decisión (single-panel) -->
      <div *ngIf="activeTab === 'motor-decision'" class="tab-pane">
        <app-approval-policy-mode></app-approval-policy-mode>
      </div>

      <!-- Tab 2: MT Scoring (sub-tabs Grupos / Condiciones) -->
      <div *ngIf="activeTab === 'mt-scoring'" class="tab-pane">
        <ul class="nav nav-pills mb-3" role="tablist">
          <li class="nav-item">
            <button class="nav-link" [class.active]="activeMtSubTab === 'groups'" (click)="setActiveMtSubTab('groups')" type="button">
              <i class="fas fa-users"></i> Grupos de Aprobación
            </button>
          </li>
          <li class="nav-item">
            <button class="nav-link" [class.active]="activeMtSubTab === 'conditions'" (click)="setActiveMtSubTab('conditions')" type="button">
              <i class="fas fa-briefcase"></i> Condiciones Laborales
            </button>
          </li>
        </ul>

        <div *ngIf="activeMtSubTab === 'groups'">
          <app-group-list
            [approvalGroups]="approvalPolicies?.approvalGroups || []"
            [availableWorkConditions]="approvalPolicies?.availableWorkConditions || []"
            (policiesUpdated)="onPoliciesUpdated()">
          </app-group-list>
        </div>

        <div *ngIf="activeMtSubTab === 'conditions'">
          <app-work-condition-master
            [allWorkConditions]="approvalPolicies?.allWorkConditions || []"
            [availableWorkConditions]="approvalPolicies?.availableWorkConditions || []"
            [refusedWorkConditions]="approvalPolicies?.refusedWorkConditions || []"
            [approvalGroups]="approvalPolicies?.approvalGroups || []"
            (policiesUpdated)="onPoliciesUpdated()">
          </app-work-condition-master>
        </div>
      </div>

      <!-- Tab 3: Credolab (sub-tabs Umbrales / Flags) -->
      <div *ngIf="activeTab === 'credolab'" class="tab-pane">
        <ul class="nav nav-pills mb-3" role="tablist">
          <li class="nav-item">
            <button class="nav-link" [class.active]="activeCredolabSubTab === 'thresholds'" (click)="setActiveCredolabSubTab('thresholds')" type="button">
              <i class="fas fa-sliders-h"></i> Umbrales
            </button>
          </li>
          <li class="nav-item">
            <button class="nav-link" [class.active]="activeCredolabSubTab === 'flags'" (click)="setActiveCredolabSubTab('flags')" type="button">
              <i class="fas fa-flag"></i> Flags auto-rechazo
            </button>
          </li>
        </ul>

        <div *ngIf="activeCredolabSubTab === 'thresholds'">
          <app-credolab-thresholds></app-credolab-thresholds>
        </div>

        <div *ngIf="activeCredolabSubTab === 'flags'">
          <app-credolab-flags></app-credolab-flags>
        </div>
      </div>

      <!-- Tab 4: Historial -->
      <div *ngIf="activeTab === 'history'" class="tab-pane">
        <div class="history-container">
          
          <!-- Header del Historial -->
          <div class="history-header">
            <h3 class="history-title">
              <i class="fas fa-history"></i>
              Historial de Cambios en Políticas
            </h3>
            <p class="history-subtitle">
              Consulta todos los cambios realizados en las políticas de aprobación
            </p>
          </div>

          <!-- Filtros -->
          <div class="history-filters">
            <div class="filter-card">
              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label">
                    <i class="fas fa-tag"></i>
                    Tipo de Acción
                  </label>
                  <select 
                    class="form-select" 
                    [(ngModel)]="historyFilters.code">
                    <option value="">Todas las acciones</option>
                    <option value="AGE_POLITICS">Política de Edad (Deprecated)</option>
                    <option value="GROUP_AGE_POLICY_UPDATE">Límites de Edad de Grupo Actualizados</option>
                    <option value="ADDED_WORK_CONDITION">Condición Laboral Agregada</option>
                    <option value="ADDED_WORK_CONDITION_TO_GROUP">Condición Agregada a Grupo</option>
                    <option value="REMOVED_WORK_CONDITION_FROM_GROUP">Condición Removida de Grupo</option>
                    <option value="CREATED_APPROVAL_GROUP">Grupo Creado</option>
                    <option value="UPDATED_APPROVAL_GROUP_INCOME_LIMITS">Límites Actualizados</option>
                    <option value="DELETED_APPROVAL_GROUP">Grupo Eliminado</option>
                    <option value="ADDED_WORK_CONDITION_TO_REFUSED_LIST">Agregada a Lista Rechazada</option>
                    <option value="REMOVED_WORK_CONDITION_FROM_REFUSED_LIST">Removida de Lista Rechazada</option>
                    <option value="APPROVAL_POLICY_MODE_UPDATE">Modo de política actualizado</option>
                    <option value="CREDOLAB_THRESHOLDS_UPDATE">Umbrales Credolab actualizados</option>
                    <option value="CREDOLAB_FLAG_UPDATE">Flag Credolab actualizado</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-label">
                    <i class="fas fa-calendar-alt"></i>
                    Fecha Inicial
                  </label>
                  <input 
                    type="date" 
                    class="form-control" 
                    [(ngModel)]="historyFilters.dateInitial"
                    placeholder="Seleccione fecha inicial">
                </div>
                <div class="col-md-3">
                  <label class="form-label">
                    <i class="fas fa-calendar-check"></i>
                    Fecha Final
                  </label>
                  <input 
                    type="date" 
                    class="form-control" 
                    [(ngModel)]="historyFilters.dateFinal"
                    placeholder="Seleccione fecha final">
                </div>
                <div class="col-md-2 d-flex align-items-end">
                  <button 
                    class="btn btn-primary w-100 mb-0"
                    (click)="applyHistoryFilters()"
                    [disabled]="loadingLogs">
                    <i class="fas fa-search"></i>
                    {{ loadingLogs ? 'Buscando...' : 'Buscar' }}
                  </button>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <button 
                    class="btn btn-outline-secondary btn-sm"
                    (click)="clearHistoryFilters()"
                    [disabled]="loadingLogs">
                    <i class="fas fa-times"></i>
                    Limpiar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Estado de carga -->
          <div *ngIf="loadingLogs" class="history-loading">
            <div class="loading-spinner">
              <i class="fas fa-spinner fa-spin"></i>
              <span>Cargando historial...</span>
            </div>
          </div>

          <!-- Lista de logs -->
          <div *ngIf="!loadingLogs && auditLogs.length > 0" class="history-logs">
            <div *ngFor="let group of auditLogs" class="log-group">
              <div class="log-group-header" [style.border-left-color]="group.color">
                <div class="log-group-icon" [style.background-color]="group.color">
                  <i class="fas fa-bolt"></i>
                </div>
                <div class="log-group-info">
                  <h4 class="log-group-title">{{ group.label }}</h4>
                  <span class="log-group-count">{{ group.records.length }} registro(s)</span>
                </div>
              </div>

              <div class="log-records">
                <div *ngFor="let record of group.records" class="log-record">
                  <div class="log-record-header">
                    <div class="log-date">
                      <i class="fas fa-clock"></i>
                      {{ formatDate(record.date) }}
                    </div>
                    <div class="log-badge" [style.background-color]="group.color + '20'" [style.color]="group.color">
                      {{ group.label }}
                    </div>
                  </div>
                  
                  <div class="log-record-body">
                    <div class="log-message">
                      <i class="fas fa-info-circle" [style.color]="group.color"></i>
                      <span [innerHTML]="record.message"></span>
                    </div>
                    
                    <div class="log-executive">
                      <i class="fas fa-user"></i>
                      <strong>Ejecutivo:</strong> {{ record.executiveName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Estado vacío -->
          <div *ngIf="!loadingLogs && auditLogs.length === 0" class="history-empty">
            <i class="fas fa-inbox"></i>
            <h4>No se encontraron registros</h4>
            <p>No hay registros que coincidan con los filtros aplicados</p>
          </div>

        </div>
      </div>

    </div>

  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && !error && !hasData()" class="empty-state">
    <i class="fas fa-database"></i>
    <h3>No hay datos de políticas disponibles</h3>
    <p>Los datos de políticas de aprobación no están disponibles en este momento.</p>
  </div>

</div>
